export default [
  'albane@foodforjoe.es',
  'flavia@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
